export enum collectionNames {
  crowns = 'crowns',
  icns = 'icns',
}
